var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import { ProctorReportStatusEnum, ProctorExamStatusEnum, ProctorReportStatusMLModelEnum, VideoModeEnum, } from "../../submodules/Assessment-Platform-1.0-Dtos-FE/src/dtos/proctor/proctorResult.dto";
import { useApplicationContext } from "../../context/application-context";
import eventBus from "../../event-worker";
import { trigger_each_question_start_video_stream_uploader, trigger_end_test_video_stream_uploader, } from "../../event-worker/event-keys";
import { useRecoilState, useRecoilValue } from "recoil";
import { instructionDataRecoil, isUploaderModalOpenRecoil, videoCurrentLengthCountRecoil, videoMaxLengthCountRecoil, } from "../../atoms/global-state";
import Webcam from "react-webcam";
import { apiClientServicesProctoring } from "../../api-client";
import { ChunkManager } from "./utils";
import proctoringService from "../../api-client/services/proc-service";
let count = 0;
export const isMobileWidth = window.innerWidth < 800;
let isFirstUpload = "true";
const startTime = new Date();
let videoChuckArray = [];
let timestampArray = [];
let videoAnswerTimeStamp = [];
let uploadGateKeeper = true;
let localisUploaderModalOpenRecoil = false;
let localVideoCurrentLengthCount = 0;
let localVideoMaxLength = 0;
const VideoChuckUploader = ({ children, userId, duration, attemptNumber, interviewId, }) => {
    const { tenantSettings } = useApplicationContext();
    const mediaRecorderRef = useRef(null);
    const lastChunkRef = useRef(null);
    const intervalRef = useRef(null);
    // Enhanced memory management
    const [chunkManager] = useState(() => new ChunkManager());
    const [uploadQueue, setUploadQueue] = useState([]);
    const [uploadGateKeeperState, setUploadGateKeeperState] = useState(true);
    const [isUploaderModalOpen, setIsUploaderModalOpen] = useRecoilState(isUploaderModalOpenRecoil);
    const [videoMaxLengthCount, setVideoMaxLengthCount] = useRecoilState(videoMaxLengthCountRecoil);
    const [videoCurrentLengthCount, setVideoCurrentLengthCount] = useRecoilState(videoCurrentLengthCountRecoil);
    const instructionData = useRecoilValue(instructionDataRecoil);
    useEffect(() => {
        const startTimestamp = new Date();
        // Start recording and set up interval on component mount
        startRecording();
        intervalRef.current = window.setInterval(() => {
            stopRecording();
            startRecording();
        }, 30000); // Stop every 0.5 min
        // catching the end-test trigger event
        eventBus.on(trigger_end_test_video_stream_uploader, catchEndTestEvent);
        // catching the question start recording event trigger event
        eventBus.on(trigger_each_question_start_video_stream_uploader, (e) => {
            catchEachQuestionStartRecording(startTimestamp, e.isResumeRecording, e.isReRecording, e.questionId);
        });
        // Cleanup on component unmount
        return () => {
            eventBus.off(trigger_end_test_video_stream_uploader, catchEndTestEvent);
            eventBus.off(trigger_end_test_video_stream_uploader, () => catchEachQuestionStartRecording(startTimestamp));
            clearInterval(intervalRef.current);
            stopRecording();
        };
    }, []);
    // Enhanced memory management cleanup
    useEffect(() => {
        return () => {
            chunkManager.cleanupAllChunks();
        };
    }, [chunkManager]);
    useEffect(() => {
        const cleanupInterval = setInterval(() => {
            chunkManager.cleanupUploadedChunks();
        }, 30000); // Clean up every 30 seconds
        return () => clearInterval(cleanupInterval);
    }, [chunkManager]);
    // catching the end-test trigger event
    const catchEndTestEvent = (e) => {
        const dirName = userId && interviewId && attemptNumber
            ? `${userId}_examId_${attemptNumber}_${interviewId}`
            : "testing";
        // `http://localhost:7017/multimedia-uploader/folder/${dirName}`
        // const url = `http://localhost:7015/proctor-gateway/folder/${dirName}`;
        const url = `/proctor-gateway/folder/${dirName}`;
        apiClientServicesProctoring.post(url);
        clearInterval(intervalRef.current);
        stopRecording();
        // Enhanced memory management check
        const stats = chunkManager.getStats();
        const totalChunks = Math.max(videoChuckArray.length, stats.totalChunks);
        if (totalChunks > 0) {
            setVideoMaxLengthCount(totalChunks);
            localVideoMaxLength = totalChunks;
            setIsUploaderModalOpen(true);
            localisUploaderModalOpenRecoil = true;
            sessionStorage.setItem("isUploaderModalOpen", "true");
            // Add timeout to close modal after 2 minutes
            setTimeout(() => {
                setIsUploaderModalOpen(false);
                localisUploaderModalOpenRecoil = false;
                sessionStorage.removeItem("isUploaderModalOpen");
            }, 120000); // 2 minutes in milliseconds
        }
        else {
            sessionStorage.removeItem("isUploaderModalOpen");
            setIsUploaderModalOpen(false);
        }
    };
    const catchEachQuestionStartRecording = (initialDate, isResumeRecording, isReRecording, questionId) => {
        const tempTimeStamp = calculateTimestampDiffInSec(initialDate);
        timestampArray.push(tempTimeStamp);
        if (questionId) {
            videoAnswerTimeStamp.push({
                questionId: questionId,
                timestamp: tempTimeStamp,
                isResumeRecording: isResumeRecording || false,
                isReRecording: isReRecording || false,
            });
        }
    };
    const calculateTimestampDiffInSec = (initialDate) => {
        const currentDate = new Date();
        const timeDifferenceMilliseconds = currentDate.getTime() - initialDate.getTime();
        const timeDifferenceSeconds = timeDifferenceMilliseconds / 1000;
        return timeDifferenceSeconds - 2;
    };
    // Function to start recording the webcam stream
    const startRecording = () => __awaiter(void 0, void 0, void 0, function* () {
        const stream = yield navigator.mediaDevices.getUserMedia({
            video: true,
            audio: true,
        });
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorder.ondataavailable = (event) => __awaiter(void 0, void 0, void 0, function* () {
            if (event.data.size > 0) {
                lastChunkRef.current = event.data; // Store the most recent chunk
                // Enhanced memory management
                const chunkId = chunkManager.addChunk(event.data);
                if (chunkId) {
                    setUploadQueue((prev) => [...prev, chunkId]);
                }
                // Backward compatibility - keep original array
                if (uploadGateKeeper) {
                    videoChuckArray.push(lastChunkRef.current);
                    sendData(videoChuckArray[0]);
                }
                else {
                    videoChuckArray.push(lastChunkRef.current);
                }
            }
        });
        mediaRecorderRef.current = mediaRecorder;
        mediaRecorder.start();
    });
    const getIsliveProcotringFlag = () => {
        var _a, _b;
        if (isUploaderModalOpen) {
            return false;
        }
        return (_b = (_a = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _a === void 0 ? void 0 : _a.isLiveProctoring) !== null && _b !== void 0 ? _b : false;
    };
    // Function to stop recording
    const stopRecording = () => __awaiter(void 0, void 0, void 0, function* () {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            if (lastChunkRef.current) {
            }
        }
    });
    const stopCompletely = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const tracks = (_b = (_a = mediaRecorderRef === null || mediaRecorderRef === void 0 ? void 0 : mediaRecorderRef.current) === null || _a === void 0 ? void 0 : _a.stream) === null || _b === void 0 ? void 0 : _b.getTracks(); // Get the tracks from the MediaStream
        if (tracks) {
            tracks.forEach((track) => track.stop()); // Stop each track
        }
        mediaRecorderRef.current = null;
    });
    const sendData = (file) => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        uploadGateKeeper = false;
        const formData = new FormData();
        // formData.append("upload", file);
        // formData.append("upload", `${count}`);
        // formData.append("upload", count.toString());
        formData.append("upload", file, `${count}.mp4`);
        console.log({ formData });
        console.log({ userId });
        console.log({ interviewId });
        console.log({ attemptNumber });
        console.log({ duration });
        console.log({ startTime });
        console.log({ isFirstUpload });
        console.log({ isUploaderModalOpen });
        console.log({ videoMaxLengthCount });
        console.log({ videoCurrentLengthCount });
        const params = {
            directoryName: userId && interviewId && attemptNumber
                ? `${userId}_examId_${attemptNumber}_${interviewId}`
                : "testing",
            userId: userId ? userId : "testing",
            examId: interviewId ? interviewId.toString() : "44",
            isFirstUpload: isFirstUpload,
            attemptNumber: attemptNumber ? attemptNumber : 1,
            examDuration: duration ? duration : 40,
            status: ProctorReportStatusEnum.PENDING,
            startTime: startTime,
            examStatus: ProctorExamStatusEnum.NOT_YET_UPDATED,
            mlModelFlag: true,
            mlModelStatus: ProctorReportStatusMLModelEnum.FINISHED,
            tenantId: tenantSettings.id,
            videoMode: VideoModeEnum.MEETING_CAPTURE,
            guiltyFlagData: timestampArray,
            videoAnswerTimeStamp: JSON.stringify(videoAnswerTimeStamp),
            avgFaceMatch: "",
            streamSettings: JSON.stringify({
                interval: ((_d = (_c = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _c === void 0 ? void 0 : _c.streamSettings) === null || _d === void 0 ? void 0 : _d.interval) || 5,
                isRequired: (_g = (_f = (_e = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _e === void 0 ? void 0 : _e.streamSettings) === null || _f === void 0 ? void 0 : _f.isRequired) !== null && _g !== void 0 ? _g : false,
                checkForPlagiarism: (_k = (_j = (_h = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _h === void 0 ? void 0 : _h.streamSettings) === null || _j === void 0 ? void 0 : _j.checkForPlagiarism) !== null && _k !== void 0 ? _k : false,
                checkForVoicePrintAnalysis: (_o = (_m = (_l = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _l === void 0 ? void 0 : _l.streamSettings) === null || _m === void 0 ? void 0 : _m.checkForVoicePrintAnalysis) !== null && _o !== void 0 ? _o : false,
            }),
            isMobileDevice: isMobileWidth,
            isLiveProctoring: getIsliveProcotringFlag(),
        };
        videoAnswerTimeStamp = [];
        isFirstUpload = "false";
        count = count + 1;
        let response = yield proctoringService.sendDataToMultiMediaService(formData, params);
        if (response) {
            if (typeof response === "object" && "overall" in response) {
                const liveResponse = response;
                console.log("liveResponse.overall", liveResponse.overall);
            }
            else {
                console.log("response is not an object");
            }
            timestampArray = [];
            videoChuckArray.shift();
            uploadGateKeeper = true;
            if (localisUploaderModalOpenRecoil && videoChuckArray.length !== 0) {
                localVideoCurrentLengthCount = localVideoCurrentLengthCount + 1;
                setVideoCurrentLengthCount(localVideoCurrentLengthCount);
                sendData(videoChuckArray[0]);
            }
            else {
                setIsUploaderModalOpen(false);
                localisUploaderModalOpenRecoil = false;
                sessionStorage.removeItem("isUploaderModalOpen");
            }
            if (videoChuckArray.length === 0 &&
                localisUploaderModalOpenRecoil &&
                localVideoCurrentLengthCount === localVideoMaxLength) {
                setIsUploaderModalOpen(false);
                localisUploaderModalOpenRecoil = false;
            }
        }
    });
    // Enhanced upload function with memory management
    const processNextChunk = () => __awaiter(void 0, void 0, void 0, function* () {
        var _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        if (uploadQueue.length === 0) {
            setUploadGateKeeperState(true);
            return;
        }
        const chunkId = uploadQueue[0];
        const blob = chunkManager.getChunk(chunkId);
        if (!blob) {
            // Remove invalid chunk from queue
            setUploadQueue((prev) => prev.slice(1));
            processNextChunk();
            return;
        }
        try {
            setUploadGateKeeperState(false);
            chunkManager.markChunkUploading(chunkId);
            const formData = new FormData();
            formData.append("upload", blob, `${count}.mp4`);
            const params = {
                directoryName: userId && interviewId && attemptNumber
                    ? `${userId}_examId_${attemptNumber}_${interviewId}`
                    : "testing",
                userId: userId ? userId : "testing",
                examId: interviewId ? interviewId.toString() : "44",
                isFirstUpload: isFirstUpload,
                attemptNumber: attemptNumber ? attemptNumber : 1,
                examDuration: duration ? duration : 40,
                status: ProctorReportStatusEnum.PENDING,
                startTime: startTime,
                examStatus: ProctorExamStatusEnum.NOT_YET_UPDATED,
                mlModelFlag: true,
                mlModelStatus: ProctorReportStatusMLModelEnum.FINISHED,
                tenantId: tenantSettings.id,
                videoMode: VideoModeEnum.STREAM,
                guiltyFlagData: timestampArray,
                videoAnswerTimeStamp: JSON.stringify(videoAnswerTimeStamp),
                avgFaceMatch: "",
                streamSettings: JSON.stringify({
                    interval: ((_q = (_p = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _p === void 0 ? void 0 : _p.streamSettings) === null || _q === void 0 ? void 0 : _q.interval) || 5,
                    isRequired: (_t = (_s = (_r = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _r === void 0 ? void 0 : _r.streamSettings) === null || _s === void 0 ? void 0 : _s.isRequired) !== null && _t !== void 0 ? _t : false,
                    checkForPlagiarism: (_w = (_v = (_u = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _u === void 0 ? void 0 : _u.streamSettings) === null || _v === void 0 ? void 0 : _v.checkForPlagiarism) !== null && _w !== void 0 ? _w : false,
                    checkForVoicePrintAnalysis: (_z = (_y = (_x = instructionData === null || instructionData === void 0 ? void 0 : instructionData.proctorConfig) === null || _x === void 0 ? void 0 : _x.streamSettings) === null || _y === void 0 ? void 0 : _y.checkForVoicePrintAnalysis) !== null && _z !== void 0 ? _z : false,
                }),
            };
            videoAnswerTimeStamp = [];
            isFirstUpload = "false";
            count = count + 1;
            const response = yield proctoringService.sendDataToMultiMediaService(formData, params);
            if (response) {
                timestampArray = [];
                // Mark as uploaded and cleanup
                chunkManager.markChunkUploaded(chunkId);
                chunkManager.cleanupChunk(chunkId);
                // Remove from queue
                setUploadQueue((prev) => prev.slice(1));
                setUploadGateKeeperState(true);
                // Continue with next chunk if modal is open
                if (localisUploaderModalOpenRecoil && uploadQueue.length > 0) {
                    localVideoCurrentLengthCount = localVideoCurrentLengthCount + 1;
                    setVideoCurrentLengthCount(localVideoCurrentLengthCount);
                    processNextChunk();
                }
                else {
                    setIsUploaderModalOpen(false);
                    localisUploaderModalOpenRecoil = false;
                    sessionStorage.removeItem("isUploaderModalOpen");
                }
            }
        }
        catch (error) {
            console.error("Upload failed:", error);
            chunkManager.markChunkFailed(chunkId);
            setUploadGateKeeperState(true);
        }
    });
    return (_jsxs("div", { children: [children, _jsx(Webcam, { imageSmoothing: true, muted: true, screenshotQuality: 0.5, screenshotFormat: "image/jpeg", style: {
                    position: "fixed",
                    marginLeft: "auto",
                    marginRight: "auto",
                    left: 0,
                    right: 0,
                    textAlign: "center",
                    zIndex: 9999,
                    // used to make webcam not visible
                    width: 320,
                    // display: "none",
                    // opacity: 0,
                    height: 240,
                } })] }));
};
export default VideoChuckUploader;
